/** Translation keys of the camera gateway's system folders. */
export const CAMERA_FOLDER_TRANSLATION_KEYS = [
  'camera_recordings_folder',
  'camera_stills_folder',
];

// The folders' deterministic ids (camera-feeds plan, section 13.2):
// camera-recordings-<projectId>[-<cameraId>], camera-stills-<projectId>-…
const CAMERA_FOLDER_ID = /^camera-(recordings|stills)-/;

/**
 * Whether a private bank item is the camera gateway's: a clip or a still,
 * or one of the folders that hold them (the Kameratallenteet folder, a
 * camera's folder, its Kuvat and day folders). The API lets only
 * `cameras_manage` delete them and its synchronous zip refuses them, so the
 * bank offers neither where it does not work.
 * @param {Object} [item] raw private item
 * @returns {boolean}
 */
export const isCameraBankItem = (item) =>
  Boolean(item) &&
  (Boolean(item.cameraId || item.cameraClipId || item.cameraStillId) ||
    CAMERA_FOLDER_TRANSLATION_KEYS.includes(item.translationKey) ||
    CAMERA_FOLDER_ID.test(String(item.id || '')));

/**
 * Whether the bank loads a private folder's contents only when it is
 * opened: a camera's folder (its clips), its Kuvat folder (a folder per day)
 * or a day folder (its stills). The API's list of the project's private
 * items leaves those contents out, as a camera files 144 stills a day; the
 * Kameratallenteet folder itself and the folders down to each Kuvat are in
 * it. A folder not loaded yet (a link into a day folder) is known by its id.
 * @param {string} folderId
 * @param {Object} [item] the folder's raw item, when loaded
 * @param {string} [projectId] the bank's project
 * @returns {boolean}
 */
export const isLazyCameraBankFolder = (folderId, item, projectId) => {
  if (!folderId) return false;
  if (item) return item.type === 'FOLDER' && Boolean(item.cameraId);
  const id = String(folderId);
  return (
    id.startsWith('camera-stills-') ||
    (Boolean(projectId) && id.startsWith(`camera-recordings-${projectId}-`))
  );
};
